exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropdown-container[data-v-cf2ea248] {\n  position: relative;\n}\n.dropdown-menu[data-v-cf2ea248] {\n  left: auto !important;\n  top: 50px !important;\n  bottom: auto !important;\n  right: 0 !important;\n  transform: none !important;\n  width: 200px !important;\n  padding: 0px !important;\n  flex-direction: column;\n  gap: 10px;\n  border-radius: 5px;\n  overflow: hidden;\n}\n.dropdown-menu > *[data-v-cf2ea248] {\n  width: 100%;\n  text-align: left;\n}\n.dropdown-menu[data-v-cf2ea248] .btn,\n.dropdown-menu[data-v-cf2ea248] button {\n  width: 100%;\n  text-align: left;\n  border-radius: 0;\n}", ""]);

// exports
